
import { 
    STATUS, 
    GSM_CHARACTERS, 
    DAYS,
    DOCTOR_CLINIC_AVAILABILITY_OPTIONS
} from "@interfaces/enum";
import cronstrue from 'cronstrue';
import htmlTags from 'html-tags';

const errorMessage = function (response, title = null) {
    let message = '';
    if (_.isObject(response)) {
        _.forEach(response, (data, key) => {
            message += "<div class='alert alert-danger' role='alert'>";
            message += _.join(data, " ");
            message += "</div>";
        });
    } else {
        message += "<div class='alert alert-danger' role='alert'>";
        message += response;
        message += "</div>";
    }
    Swal.fire({
        title: title ? title : 'Error!',
        html: message,
        type: 'error',
        width: 400
    });
}
const getStatus = function (status, type = "bg") {
    let color = "";
    switch (status) {
        case STATUS.PENDING:
        case STATUS.UNPAID:
        case STATUS.FOR_APPROVAL:
        case STATUS.FOR_SENDING:
            color = "-warning";
            break;
        case STATUS.ACTIVATED:
        case STATUS.PAID:
        case STATUS.DONE:
            color = "-success";
            break;
        case STATUS.APPROVED:
        case STATUS.SENDING:
            color = "-primary";
            break;
        case STATUS.CANCELLED:
        case STATUS.DECLINED:
        case STATUS.EXPIRED:
        case STATUS.FAILED:
            color = "-danger";
            break;
        case STATUS.REFUNDED:
        case STATUS.DELETED:
        case STATUS.TRANSACTION_PENDING:
            color = "-dark";
            break;


        default:
            break;
    }
    return `${type}${color}`;
}
const checkingApiRequest = function (state, method) {

    var cancelToken = state.cancelSources[method];
    if (!_.isEmpty(cancelToken)) {
        cancelToken.cancel()
    }
    var payload = {
        method: method,
        newToken: axios.CancelToken.source()
    }
    state.cancelSources[method] = axios.CancelToken.source();
    // commit('setCancelSources', payload)

}

const isOdd = function (value) {
    return Math.abs(value % 2) == 1;
}

const removeNonGsmCharset = function (string) {
    var gsm = GSM_CHARACTERS; //"@ £$¥èéùìòÇØøÅåΔ_ΦΓΛΩΠΨΣΘΞ^{}\[~]|€ÆæßÉ!\"#¤%&'()*+,-./0123456789:;<=>?¡ABCDEFGHIJKLMNOPQRSTUVWXYZÄÖÑÜ§¿abcdefghijklmnopqrstuvwxyzäöñüà";
            
    if (gsm) {
        var letters = string.split('');
        
        _.forEach(letters, letter => {
            var check = gsm.indexOf(letter) !== -1;
            if (!check) {
                string = string.replace(letter,"<span class='bg-danger text-white py-1 px-2'>"+ letter +"</span>")
            }
        });
    }

    // Regular expression to match invalid HTML entities (e.g., &frac12 without a semicolon)
    const invalidEntityPattern1 = /&([a-zA-Z0-9]+)(?![a-zA-Z0-9]*;)/g;

    // Replace invalid HTML entities with a red-colored span (styled)
    string = string.replace(invalidEntityPattern1, (match, p1) => {
        return match != "&nbsp" ? `<span class='bg-danger text-white py-1 px-2'>${_.escape(match)}</span>` : match; // Wrap invalid entities in a red span
    });

    string = checkValidHtmlTags(string);

    return string;
}

const checkValidHtmlTags = function (str) {
    // Regular expression to match HTML tags
    const regex = /<\/?([a-zA-Z]+)([^>]*>)/g;
    // Replace tags if they are not valid HTML tags
    return str.replace(regex, (match, tagName) => {
        // If the tag is valid, leave it as is, otherwise replace with a styled <span>
        if (htmlTags.includes(tagName.toLowerCase())) {
            return match; // Keep valid HTML tags as is
        } else {
            return `<span class='bg-danger text-white py-1 px-2'>${_.escape(match)}</span>`; // Replace invalid tags with styled span
        }
    });
}

const replaceAll = function (string, target, replacement) {
    if (string) {
        string = _.replace(string, new RegExp(target, "g"), replacement);
    }
    
    return string;
}

const formatAppointmentSchedule = function (appointment) {
    let schedule = appointment.doctor_schedule; 
    let appointment_date = appointment.appointment_date;
    let reschedule = appointment.reschedule ? appointment.reschedule : getAppointmentReschedule(appointment);
    const time = formatTime(appointment_date);
    let sched = "";
    let last_sched = "";

    if (appointment_date && appointment_date != "0000-00-00 00:00:00") {
        if (reschedule) {

            sched += formatDay(appointment_date);
            if (formatTime(appointment_date)!='12:00am') {
                sched += ", " + formatTime(appointment_date);
            } else {
                sched += ", Any time of the day";
            }
            sched += ", " + moment(appointment_date).format("MMM D, YYYY");

            if (schedule) {
                if (schedule.day) {
                    last_sched += getDayName(schedule.day);
                }                    
                if (schedule.from_day || schedule.to_day) {
                    last_sched += ", " + schedule.from_day + " - " + schedule.to_day;
                } else { 
                    if (schedule.availability) {
                        last_sched += ", Whole " + _.capitalize(schedule.availability);
                    } else {
                        last_sched += ", Any time of the day";
                    }
                }
            } else {
                last_sched += formatDay(reschedule);
                if (reschedule.time!='null') {
                    last_sched += ", " + reschedule.time;
                } else {
                    last_sched += ", Any time of the day";
                }
            }
            
            last_sched += ", " + moment(reschedule.reschedule).format("MMM D, YYYY");
        } else {
            if (schedule) {
                if (schedule.day) {
                    sched += getDayName(schedule.day);
                }                    
                if (schedule.from_day || schedule.to_day) {
                    if (formatTime(appointment_date)!='12:00am') {
                        sched += ", " + formatTime(appointment_date);
                    } else {
                        sched += ", " + schedule.from_day + " - " + schedule.to_day;
                    }
                } else { 
                    if (formatTime(appointment_date)!='12:00am') {
                        sched += ", " + formatTime(appointment_date);
                    } else {
                        if (schedule.availability) {
                            sched += ", Whole " + _.capitalize(schedule.availability);
                        } else {
                            sched += ", Any time of the day";
                        }
                    }
                }
            } else {
                sched += formatDay(appointment_date);
                if (formatTime(appointment_date)!='12:00am') {
                    sched += ", " + formatTime(appointment_date);
                } else {
                    sched += ", Any time of the day";
                }
            }
            
            sched += ", " + moment(appointment_date).format("MMM D, YYYY");
        }
    } else {                
        sched += "N/A";
    }

    return {
        sched,
        last_sched
    };
}

const getDayName = function (day) {
    const day_key = _.findIndex(DAYS, { value: day });
    return DAYS[day_key].text;
}

const formatTime = function (value) {
    return !_.isEmpty(value)
        ? moment(value).format("h:mma")
        : null;
}

const formatDay = function (value) {
    return !_.isEmpty(value)
        ? moment(value).format("dddd")
        : null;
}

const formatDate = function (value) {
    return value 
    ? moment(value).format("YYYY-MM-DD") 
    : null
}

const getAppointmentReschedule = function (item) {
    let reschedule = null;
    var remarks = item.remarks;

    if (_.includes(remarks, 'reschedule:')) {
        reschedule = _.split(remarks, ":");
        var i = 1;
        var reschedule_arr = {}
        _.forEach(reschedule, item => {
            if (isOdd(i)) {
                if (item=='time') {
                    reschedule_arr[item] = reschedule[i].replace("-", ":");
                    reschedule_arr[item] = reschedule_arr[item].replace(" ", "");
                    reschedule_arr[item] = _.toLower(reschedule_arr[item])
                } else {
                    reschedule_arr[item] = reschedule[i]
                }
            }
            i++;
        });
        reschedule = reschedule_arr;
    }        
    return reschedule;
}

const getUserStatus = function (item) {
    let label = "";
    let badge = "";
    if (!item.deleted_at) {
        if (item.active) {
            label = "ACTIVE";
            badge = "badge-success";
        } else {
            label = "DEACTIVATED";
            badge = "badge-danger";
        }
    } else {
        label = "DELETED";
        badge = "badge-dark";
    }
    return {
        label,
        badge
    }
}

const getDoctorClinicAvailabilityName = function (value) {
    const key = _.findIndex(DOCTOR_CLINIC_AVAILABILITY_OPTIONS, { value });
    return DOCTOR_CLINIC_AVAILABILITY_OPTIONS[key].text;
}

// Announcement
const getETC = function (date, overall, limit, seconds, add) {
    let completed = _.round((overall/limit) * seconds);
    let estimated = moment(date).add(completed, 'seconds');
    return moment(estimated).add(add, 'minutes');
}

const getETCStatus = function (etc, date) {
    const schedule = moment(date).format("YYYY-MM-DD HH:mm");
    const etc_datetime = moment(etc).format("YYYY-MM-DD HH:mm");
    const current_datetime = moment(new Date()).format("YYYY-MM-DD HH:mm");

    let status = moment(new Date()).isBetween(schedule, etc_datetime)
    ? "on-going"
    : ((moment(current_datetime).isBefore(etc_datetime)) 
        ? "pending"
        : "done");
    
    let color = "";
    if (status=="on-going") {
        color = "success";
    } else if (status=="done") {
        color = "primary";
    } else if (status=="pending") {
        color = "warning";
    }

    return {
        status,
        color
    }
}

// String
const convetToAbbrv = function (string) {
    if (!string) return '';
    return _.toUpper(_.join(_.map(_.split(string, ' '), _.first), ''));
}

// Date
const dateDuration = function (end, start = moment(new Date())) {
    if (!end) return '';
    var duration = moment.duration((moment(end)).diff(start));
    return duration.asHours();
}

const dateIsAfter = function (date) {
    if (!date) return false;
    // Parse the date using moment, assuming it could be a string or moment object
    const parsedDate = moment(date);
    // Check if the parsed date is valid
    if (!parsedDate.isValid()) return false;
    // Compare the current moment with the provided date
    return moment().isAfter(parsedDate);
}  

const checkDateRangeStatus = function (start_at, end_at) {
    const now = new Date();
    const startAt = new Date(start_at);
    const endAt = new Date(end_at);

    // Normalize the dates to ignore time part
    now.setHours(0, 0, 0, 0);
    startAt.setHours(0, 0, 0, 0);
    endAt.setHours(0, 0, 0, 0);

    if (now < startAt) {
      return 'pending';
    } else if (now >= startAt && now <= endAt) {
      return 'on_going';
    } else {
      return 'expired';
    }
}  

const getDateRangeStatusColor = function (start_at, end_at) {
    const status = checkDateRangeStatus(start_at, end_at)
    let text_color = "";
    switch(status) {
        case "pending":
            text_color = "warning";
            break;
        case "on_going":
            text_color = "success";
            break;
        case "expired":
            text_color = "danger";
            break;
    }
    return text_color;
}

const addEmptyObject = function (array) {
    const new_object = {
        value: null,
        text: ""
    };
    return [new_object].concat(array);
}

const removeAllObject = function (array) {
    return _.remove(array, function(n) {
        return n.value != null;
    })
}

const getAuditName = function (params, name) {
    if (_.isEmpty(params[ name ].toString())) {
        return "";
    }

    let key = `${ name }_admin`;

    if (!_.isEmpty(params[ key ])) {
        if (!_.isEmpty(params[ key ].full_name)) {
            return params[ key ].full_name
        }
        return params[ key ].first_name + ' ' + params[ key ].last_name;
    }

    if (!_.isEmpty(params.admin)) {
        const { first_name, last_name } = params.admin
        return params.admin.first_name + ' ' + params.admin.last_name;
    }
}

const getImageSize = function (img, callback) {
    var image = new Image();
    image.src = img;
    image.onload = function() {
        var result = { 
            width: image.width, 
            height: image.height
        };
        callback(result);
    };
}

const getImageSizeExceedMessage = function (width, height, limit) {
    return "Image Dimensions Exceed Limit!<br>(Your image size: "+ width + " x " + height + ") <br>Please choose an image with dimensions within <b>" + limit + " x " + limit + "</b>"
}
const getUserTypeColor = function (user_type, type = "bg") {
    let color = "";
    switch (user_type) {
        case 'doctor':
            color = "primary";
            break;
        case 'dentist':
            color = "info";
            break;
        case 'patient':
            color = "success";
            break;
        case 'pharmacist':
            color = "indigo";
            break;
        case 'pharma_user':
            color = "dark";
            break;
        case 'drugstore':
            color = "warning";
            break;
        case 'client':
            color = "secondary";
            break;
        case 'vet_client':
            color = "light";
            break;
        case 'vet_doctor':
            color = "orange";
            break;
        case 'pet_owner':
            color = "indigo";
            break;
        case 'business_owner':
            color = "secondary";
            break;
        default:
            break;
    }
    return `${type}-${color}`;
}

const getDiseaseTypeColor = function (disease_type, type = "bg") {
    let color = "";
    switch (disease_type) {
        case 'acute':
            color = "danger";
            break;
        case 'chronic':
            color = "primary";
            break;
        default:
            break;
    }
    return `${type}-${color}`;
}

const getStatusColor = function (status, type = "bg") {
    let color = "";
    switch (status) {
        case 'Active':
            color = "success";
            break;
        case 'Active/Sub':
            color = "primary";
            break;
        case 'Inactive':
            color = "warning";
            break;
        case 'deleted':
            color = "dark";
            break;
        case 'Inactive/Syn':
            color = "orange";
            break;
        default:
            break;
    }
    return `${type}-${color}`;
}

const getSenderColor = function (user_type, type = "bg") {
    let color = "";
    switch (user_type) {
        case 'tfd':
            color = "primary";
            break;
        case 'ppd':
            color = "success";
            break;
        case 'eul':
            color = "indigo";
            break;
        case 'pvet':
            color = "warning";
            break;
        case 'rona':
            color = "secondary";
            break;
        case 'ag':
            color = "light";
            break;
        case 'tfv':
            color = "orange";
            break;
        default:
            break;
    }
    return `${type}-${color}`;
}

const addAll = function (end) {
    const start = [{ value: null, text: "All" }];
    return start.concat(end);
}

const addNewOption = function (arr, option) {
    const start = [option];
    return start.concat(arr);
}

const generateRandomAlphanumeric = function (length = 8) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    return _.times(length, () => _.sample(characters)).join('');
}

const getLocation = function (item) {
    if (!item.region && !item.province && !item.municipality) {
        return null;
    } else {
        let regionCode = item.region ? item.region.region_code : '<span title="Region Code" class="badge badge-dark">N/A</span>';
        let regionName = item.region ? item.region.region_name : '<span title="Region Name" class="badge badge-dark">N/A</span>';
        let provinceName = item.province ? item.province.province_name : '<span title="Province Name" class="badge badge-dark">N/A</span>';
        let municipalityName = item.municipality ? item.municipality.municipality_name : '<span title="Municipality Name" class="badge badge-dark">N/A</span>';

        return `${regionCode} - ${regionName}, ${provinceName}, ${municipalityName}`;
    }
}

const generateProfileColor = function (string) {
    const colors = [
        { bg: "#F2D7D5", text: "#641E16" },
        { bg: "#D6DBDF", text: "#212F3C" },
        { bg: "#EBDEF0", text: "#512E5F" },
        { bg: "#E8DAEF", text: "#4A235A" },
        { bg: "#D4E6F1", text: "#154360" },
        { bg: "#D6EAF8", text: "#1B4F72" },
        { bg: "#FCF3CF", text: "#7D6608" },
        { bg: "#FAE5D3", text: "#784212" },
        { bg: "#D1F2EB", text: "#0E6251" },
        { bg: "#F6EEA7", text: "#726600" },
        { bg: "#FADBD8", text: "#78281F" },
        { bg: "#F6DDCC", text: "#BA4A00" },
    ]
    // Simple computation based on the length of the input string
    let index = nameToNumber(string) % colors.length;
        index = (index < 0) ? 0 : index;
    // Return the color at the computed index
    return colors[index];
}

const nameToNumber  = function (name) {
    return name.toUpperCase().split('').reduce((sum, char) => sum + char.charCodeAt(0) - 64, 0);
}

const truncate  = function (string, lenght = 30, ommision = '...') {
    return _.truncate(string, { 'length': lenght, 'omission': ommision } );
}

const generateRandomId = function (length = 8) {
    const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let randomId = '';
    for (let i = 0; i < length; i++) {
      randomId += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return randomId;
}

const formatBrandName = function (brand, size = 'f12', color = 'text-dark') {
    let name = brand.brand_name;
    if (brand.suffix) {
        name += " <span class='"+ size +" "+ color +"'>" + brand.suffix + "</span>"
    }
    return name;
}

const readableExpression  = function (cron) {
    return cronstrue.toString(cron, { locale: 'en' });
}

const formatFullName2 = function (item) {
    let full_name = '';
    if (item) {
        if (item.first_name) {
            full_name += item.first_name + ' ';
        }
        if (item.middle_name) {
            full_name += item.middle_name + ' ';
        }
        if (item.last_name) {
            full_name += item.last_name;
        }
    }
    return full_name;
};

const generateUUID = function () {
    return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
    (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
    );
};

const getText = function (array, value) {
    const data = _.find(array, { value })
    return data ? data.text : (value ?? null);
};

const arrayToUrlParams = function (params) {
    const queryParams = _.map(
        _.omitBy(params, value => value === null || value === ""),
        (value, key) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
    ).join("&");
    return queryParams;
};

const shortenLabel = function (label, maxLength = 10) {
    if (label.length <= maxLength) {
        return label; // No need to shorten
    }
    const len = label.length;
    const start_len = (len/2) - 3;
    const end_len = - (len/2);
    const start = label.slice(0, 3);  // First part
    const end = label.slice(-4);       // Last part

    return `${start}...${end}`;
}

const getFileName = function (path) {
    const parts = path.split('/');
    return parts[parts.length - 1];
};

const downloadFile = function (fileURL) {
    // Create an anchor element for downloading
    const downloadLink = document.createElement('a');
    downloadLink.href = fileURL;
    downloadLink.target = '_blank';
    downloadLink.download = 'file.jpg';

    // Trigger a click event on the anchor element to open the file in a new tab
    downloadLink.click();
};

export default {
    errorMessage,
    checkingApiRequest,
    getStatus,
    isOdd,
    removeNonGsmCharset,
    replaceAll,
    formatAppointmentSchedule,
    getDayName,
    formatTime,
    formatDay,
    getAppointmentReschedule,
    getUserStatus,
    getETC,
    getETCStatus,
    dateDuration,
    dateIsAfter,
    addEmptyObject,
    removeAllObject,
    getAuditName,
    convetToAbbrv,
    formatDate,
    getImageSize,
    getImageSizeExceedMessage,
    getDoctorClinicAvailabilityName,
    getUserTypeColor,
    getDiseaseTypeColor,
    getStatusColor,
    getSenderColor,
    addAll,
    generateRandomAlphanumeric,
    getLocation,
    generateProfileColor,
    nameToNumber,
    truncate,
    generateRandomId,
    formatBrandName,
    readableExpression,
    checkDateRangeStatus,
    addNewOption,
    formatFullName2,
    generateUUID,
    getText,
    getDateRangeStatusColor,
    arrayToUrlParams,
    shortenLabel,
    getFileName,
    downloadFile
}